module.exports = __webpack_public_path__ + "img/patrocinadores_trapiche.ebba8000.png";